import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IPortalUnitSearchModel } from '@apps-common/types/portal/unit'

export const QUERY_KEY_GET_DASH_RECENT_PENDING_CANCEL_LIST = (take = 8) => ['getDashRecentPendingCancelList', take]

export const getDashRecentPendingCancelList = async (take: number): Promise<IPortalUnitSearchModel[]> =>
  axios.get(`/dashwidget/getrecentpendingcancelunitlist?take=${take}`).then((res) => res.data?.data)

type QueryFnType = typeof getDashRecentPendingCancelList

type Props = {
  config?: QueryConfig<QueryFnType>
  take: number
}

export const useGetDashRecentPendingCancelList = ({ config, take }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getDashRecentPendingCancelList', take],
    queryFn: () => getDashRecentPendingCancelList(take)
  })
